export const CANVAS_ELEMENT = document.getElementById("canvas");
export const SCORE_ELEMENT = document.getElementById("score");
export const CTX = canvas.getContext("2d");
CTX.imageSmoothingEnabled = false;

export const BG_IMAGE = document.getElementById("bgBoard");
export const COIN_IMAGE = document.getElementById("coin");
export const PILL_IMAGE = document.getElementById("pill");
export const ISAAC_SPRITE = document.getElementById("isaacSprite");
export const ISAAC_POWERUP = document.getElementById("isaacPowerup");
export const ENNEMY_HEAD = document.getElementById("ennemyHead");
export const ENNEMY_BODY = document.getElementById("ennemyBody");
